export default [
  {
    path: '/configurations/:configurationId/payments',
    component: () => import(/* webpackChunkName: "PaymentJobs" */ '@/views/PaymentJobs.vue'),
    meta: {
      noContextRequired: true,
      permissions: ['Portal.PaymentJobs.Read']
    },
    children: [
      {
        path: '',
        name: 'paymentJobsOverview',
        component: () => import(/* webpackChunkName: "PaymentJobsOverview" */ '@/components/PaymentJobs/Overview/PaymentJobsOverview.vue'),
        meta: {
          permissions: ['Portal.PaymentJobs.Read']
        },
        props: true
      },
      {
        path: ':paymentJobReference',
        name: 'paymentJobDetail',
        component: () => import(/* webpackChunkName: "PaymentJobsDetail" */ '@/components/PaymentJobs/Detail/PaymentJobDetail.vue'),
        meta: {
          permissions: ['Portal.PaymentJobs.Read']
        },
        props: true
      },
      {
        path: ':paymentJobReference/trace/:traceReference',
        name: 'paymentJobTrace',
        component: () => import(/* webpackChunkName: "PaymentJobsTrace" */ '@/components/PaymentJobs/Trace/PaymentJobTrace.vue'),
        meta: {
          permissions: ['Portal.PaymentJobs.Read', 'Portal.Traces.Read']
        },
        props: true
      }
    ]
  }
]
